var _path, _path2, _path3, _path4, _path5, _path6, _circle, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg404IllustrationMed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 704,
    height: 535,
    viewBox: "0 0 704 535",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "_404_illustration",
    "data-name": "404_illustration",
    transform: "translate(-32 -125.068)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ic_blob_2",
    d: "M62.182,1.5c25.546-12.056-1.645,50.982,6.409,110.614S149.335,220.253,201.78,214.46s84.932-76.6,44.5-103.644c0,0,41.127,2.046,50.162,44.533s-12.26,80.672-43.483,82.876-47.458,22.294-59.194,22,4.262-6.472-2.292-14.936-53.25-.857-109.675-27.4-68.531-53.7-79.082-91.738,12.215,5.982,23.934-1.229.916-26.19,2.314-44.759,9.552-36.324,20.667-23.935S49.9,7.291,62.182,1.5Z",
    transform: "translate(224.58 264.964) rotate(45)",
    fill: "#fff",
    opacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "ic_blob_1",
    d: "M123.784,19.393C128.622-4.86,190.493-9.121,236.63,22.565s53.084,66.1,42.866,65,42.315,27.365,60.985,95.832S339.43,331.313,279.5,375.726c0,0,39.393-40.588,32.275-114.731s-91.415-89-108.544-109.3-3.777-50.849,27.312-55.652,4.7-42.946-28.953-43.952-59.856,7.058-64.444.636S47.724,60.951,30.861,125.813s-41.188,46.046-26.156,0,113.137-91.763,131.488-95.2S122.664,25.019,123.784,19.393Z",
    transform: "matrix(1, 0.017, -0.017, 1, 305.627, 125.068)",
    fill: "#fff",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "ic_404",
    transform: "translate(234 364.069)"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2941",
    "data-name": "Path 2941",
    d: "M62.654,0A62.915,62.915,0,1,1,0,62.914,62.785,62.785,0,0,1,62.654,0Z",
    transform: "translate(90.942 4.17)",
    fill: "#003fb9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2940",
    "data-name": "Path 2940",
    d: "M62.654,0A62.915,62.915,0,1,1,0,62.914,62.785,62.785,0,0,1,62.654,0Z",
    transform: "translate(90.942 4.17)",
    fill: "#fff",
    opacity: 0.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_123",
    "data-name": "Path 123",
    d: "M140.319,166.639c7.783-3.774,11.561-6.846,10.842-2.6-.783,4.615.079,11.129.079,11.129s1.3,2.453,5.093,1.36c3.778-1.093,3.512-1.627,5.133-1.627s12.192.267,8.931,4.348-1.892,5.98-4.867,6.806c-2.975.8-4.064,4.882-4.33,5.708-.271.806-3.227,3.527-3.227,3.527L151.2,197.93a60.888,60.888,0,0,0,7.31,8.824,59.408,59.408,0,0,0,4.842,4.392,13.306,13.306,0,0,1,5.975-1.979c3.512,0,4.044,1.894,5.768,2.617,1.724.742,1.542,0,1.542,0s1.621,2,3.384,1.093,7.97.079,9.054.079,5.956-2.162,8.153-.594c2.217,1.563,2.69,1.153,2.956,3.047.207,1.464.1,4.437-2.768,9.527a61.562,61.562,0,0,0,19.605-1.4c-2.63-1.568-1.4-11.669-3.532-16.021-2.113-4.328-2.2-5.421-1.4-7.34.823-1.894,2.443,0,3.8,0s3.778-1.627,4.069-4.615a33.068,33.068,0,0,1,1.33-6.247s2.448-4.62,3.532-4.62,4.335.272,5.423-.267c1.064-.554,1.064-1.36,1.621-2.78.532-1.425.8-7.835-.557-7.548-1.355.267-4.044-1.113-4.044-1.113a33.967,33.967,0,0,0-4.887-.989c-.8.084-1.089-2.533-1.089-2.533s5.158-2.993,5.158-4.086c0-1.068-1.892-1.335-2.158-4.615-.286-3.279,2.424-3.26,5.4-2.681s0,1.321,0,3.9.266,2.33,3.532,0c3.246-2.35,2.424.143,3.246,0a29.2,29.2,0,0,1,4.862.821s-.266,6.663,0,13.464,10.285.267,13.266-2.167c1.433-1.172,5.6-.6,9.463,1.385a62.924,62.924,0,0,0-9.813-49.128.627.627,0,0,1-.719.124c-1.192-.514-4.887.579-5.69-.228-.818-.826-4.33.806-6.074,0-1.768-.826-3.143-2.988-3.266-5.832S237,114,235.642,110.4c-.434-1.153-.512-1.692-.227-1.855a62.555,62.555,0,0,0-50.546-6.579c2.32,3.937,4.084,8.453,1.64,10.412-4.739,3.814-2.113,7.073,1.172,10.061,3.305,2.988,1.049,5.708,0,6.8-1.025,1.073-2.916,3.794-1.172,5.154,1.768,1.36,5.67,2.993,2.9,4.62-2.749,1.647-1.128,5.708-5.749,2.186-4.6-3.547-2.975-6.806-6.488-6.806s-4.064,4.081-8.665,5.446-4.862,1.088-6.217.534c-1.36-.534-1.36-4.061-4.335-7.073a4.161,4.161,0,0,0-6.793.826c-.517,1.36-1.379,7.692,0,8.473,1.374.762-.246,5.115-2.961,5.936-2.542.767-5.374-3.482-6.364-.678a4.748,4.748,0,0,0-.163.678,1.8,1.8,0,0,1-.079.312A62.489,62.489,0,0,0,140.319,166.639ZM204.786,197.2c-4.33,1.088,0,0-4.537-5.164s2.562-1.632,2.562-1.632a64.83,64.83,0,0,0,1.99-7.613c.557-3.265,4.586,0,6.822,0s4.532,3.265,1.872,7.613c0,0,.227,2.716-1.872,2.176S209.116,196.109,204.786,197.2Zm-1.975,7.34c1.276-.816,4.414,1.088,3.9,4.62l-4.064,1.088a21.227,21.227,0,0,1-3.911-3.492C197.559,205.166,201.539,205.354,202.81,204.538Zm-33.221-48.391c0-2.721.808-4.729,2.98-5.233,3.5-.816,4.345,2.513,7.453,2.785s1.749,8.562,1.749,8.562,1.108,4.214-4.453,2.859-8.542-.3-9.079-2.33S169.589,158.868,169.589,156.147Z",
    transform: "translate(-49.216 -95.179)",
    fill: "#fff",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_43",
    "data-name": "Group 43",
    transform: "translate(216.205)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_124",
    "data-name": "Path 124",
    d: "M188.352,114.335a9.534,9.534,0,1,1-9.532-9.537A9.53,9.53,0,0,1,188.352,114.335Z",
    transform: "translate(-169.283 -104.798)",
    fill: "#407bff",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_125",
    "data-name": "Path 125",
    d: "M188.352,114.335a9.534,9.534,0,1,1-9.532-9.537A9.53,9.53,0,0,1,188.352,114.335Z",
    transform: "translate(-169.283 -104.798)",
    fill: "#fff",
    opacity: 0.6
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17",
    "data-name": "Ellipse 17",
    cx: 1.935,
    cy: 1.935,
    r: 1.935,
    transform: "translate(2.915 10.86)",
    opacity: 0.1
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_126",
    "data-name": "Path 126",
    d: "M172.7,106.9a.355.355,0,1,1-.355-.355A.353.353,0,0,1,172.7,106.9Z",
    transform: "translate(-158.64 -97.924)",
    opacity: 0.1
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_127",
    "data-name": "Path 127",
    d: "M171.632,108.463a.355.355,0,1,1-.355-.355A.353.353,0,0,1,171.632,108.463Z",
    transform: "translate(-162.844 -91.803)",
    opacity: 0.1
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_128",
    "data-name": "Path 128",
    d: "M172.322,105.407a.355.355,0,1,1-.355-.355A.356.356,0,0,1,172.322,105.407Z",
    transform: "translate(-160.135 -103.801)",
    opacity: 0.1
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_129",
    "data-name": "Path 129",
    d: "M173.561,107.089a.355.355,0,1,1-.355-.355A.353.353,0,0,1,173.561,107.089Z",
    transform: "translate(-155.271 -97.197)",
    opacity: 0.1
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_130",
    "data-name": "Path 130",
    d: "M170.584,106.482a.355.355,0,1,1-.355-.355A.353.353,0,0,1,170.584,106.482Z",
    transform: "translate(-166.959 -99.58)",
    opacity: 0.1
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_131",
    "data-name": "Path 131",
    d: "M172.946,106.637a1.224,1.224,0,1,1-1.227-1.227A1.223,1.223,0,0,1,172.946,106.637Z",
    transform: "translate(-164.513 -102.395)",
    opacity: 0.1
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_132",
    "data-name": "Path 132",
    d: "M174.342,108.9a1.227,1.227,0,1,1-1.226-1.222A1.227,1.227,0,0,1,174.342,108.9Z",
    transform: "translate(-159.052 -93.471)",
    opacity: 0.1
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2818",
    "data-name": "Path 2818",
    d: "M-64.12-15.6V-32.16l37.9-54.24H-3.312v53.04H6.522V-15.6H-3.312V0H-23.821V-15.6Zm41.738-48.24L-42.532-33.36h20.149ZM165.238-15.6V-32.16l37.9-54.24h22.908v53.04h9.835V-15.6h-9.835V0H205.536V-15.6Zm41.738-48.24L186.826-33.36h20.149Z",
    transform: "translate(64.12 108.906)",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_Character",
    transform: "translate(534.08 338.948)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87",
    "data-name": "Group 87"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_264",
    "data-name": "Path 264",
    d: "M347.893,246.781l31.919-2.315.274-1.248c1.048-4.922,4.783-23.4,4.2-35.152a24.974,24.974,0,0,0-.954-6.18c-3.9-12.117-42.176-36.548-42.176-36.548l-1.864,14.7L361.8,208.219C354.881,223.759,347.893,246.781,347.893,246.781Z",
    transform: "translate(-255.273 -121.295)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_265",
    "data-name": "Path 265",
    d: "M347.893,246.781l31.919-2.315.274-1.248c1.048-4.922,4.783-23.4,4.2-35.152a24.974,24.974,0,0,0-.954-6.18c-3.9-12.117-42.176-36.548-42.176-36.548l-1.864,14.7L361.8,208.219C354.881,223.759,347.893,246.781,347.893,246.781Z",
    transform: "translate(-255.273 -121.295)",
    fill: "#fff",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_73",
    "data-name": "Group 73",
    transform: "translate(0 164.181)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_266",
    "data-name": "Path 266",
    d: "M322.164,287.109c-3.979,2.734-8.009,5.665-11.976,8.458-1.971,1.429-3.963,2.8-5.916,4.15-1.932,1.341-3.924,2.639-5.664,3.676-.422.253-.847.5-1.169.673-.359.2-.569.287-.51.325a1.606,1.606,0,0,1,.36-.045l.092,0-.1.019-.205.04-.817.157-1.688.307c-2.295.42-4.7.757-7.119,1.156-4.844.775-9.825,1.522-14.757,2.627l-.084.019a4.572,4.572,0,0,0-.123,8.894,102.244,102.244,0,0,0,15.35,2.548c2.6.258,5.207.387,7.917.434.686.01,1.349.017,2.061-.013l1.054-.034.264-.009.135-.005.323-.041c.429-.06.861-.134,1.284-.221a23.345,23.345,0,0,0,3.033-.937c.834-.311,1.538-.615,2.238-.923,2.737-1.232,5.046-2.531,7.377-3.834,2.3-1.313,4.507-2.693,6.7-4.068,4.352-2.821,8.523-5.679,12.638-8.878a9,9,0,0,0-10.6-14.543Z",
    transform: "translate(-255.273 -285.476)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_267",
    "data-name": "Path 267",
    d: "M322.164,287.109c-3.979,2.734-8.009,5.665-11.976,8.458-1.971,1.429-3.963,2.8-5.916,4.15-1.932,1.341-3.924,2.639-5.664,3.676-.422.253-.847.5-1.169.673-.359.2-.569.287-.51.325a1.606,1.606,0,0,1,.36-.045l.092,0-.1.019-.205.04-.817.157-1.688.307c-2.295.42-4.7.757-7.119,1.156-4.844.775-9.825,1.522-14.757,2.627l-.084.019a4.572,4.572,0,0,0-.123,8.894,102.244,102.244,0,0,0,15.35,2.548c2.6.258,5.207.387,7.917.434.686.01,1.349.017,2.061-.013l1.054-.034.264-.009.135-.005.323-.041c.429-.06.861-.134,1.284-.221a23.345,23.345,0,0,0,3.033-.937c.834-.311,1.538-.615,2.238-.923,2.737-1.232,5.046-2.531,7.377-3.834,2.3-1.313,4.507-2.693,6.7-4.068,4.352-2.821,8.523-5.679,12.638-8.878a9,9,0,0,0-10.6-14.543Z",
    transform: "translate(-255.273 -285.476)",
    fill: "#fff",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_268",
    "data-name": "Path 268",
    d: "M296.929,304.391s6.471,9.727,5.006,15.557l1.975-.659s-.541-10.722-6.471-15.223Z",
    transform: "translate(-255.273 -285.476)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_71",
    "data-name": "Group 71",
    transform: "translate(0 23.656)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_269",
    "data-name": "Path 269",
    d: "M270.716,309.132l-8.668,1.08,5.228,8.157s7.675-1.431,6.772-5.354Z",
    transform: "translate(-255.273 -309.132)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_270",
    "data-name": "Path 270",
    d: "M255.273,315.592l6.876,5.488,5.127-2.711-5.227-8.157Z",
    transform: "translate(-255.273 -309.132)",
    fill: "#407bff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_72",
    "data-name": "Group 72",
    transform: "translate(0 23.656)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_271",
    "data-name": "Path 271",
    d: "M270.716,309.132l-8.668,1.08,5.228,8.157s7.675-1.431,6.772-5.354Z",
    transform: "translate(-255.273 -309.132)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_272",
    "data-name": "Path 272",
    d: "M255.273,315.592l6.876,5.488,5.127-2.711-5.227-8.157Z",
    transform: "translate(-255.273 -309.132)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_273",
    "data-name": "Path 273",
    d: "M270.716,309.132s3.553,4.332.606,7.957l1.167.478s4.711-2.986.207-8.913Z",
    transform: "translate(-255.273 -285.476)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_274",
    "data-name": "Path 274",
    d: "M296.929,304.391s6.471,9.727,5.006,15.557l1.975-.659s-.541-10.722-6.471-15.223Z",
    transform: "translate(-255.273 -285.476)",
    fill: "#003fb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275",
    "data-name": "Path 275",
    d: "M270.716,309.132s3.553,4.332.606,7.957l1.167.478s4.711-2.986.207-8.913Z",
    transform: "translate(-255.273 -285.476)",
    fill: "#003fb9"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_276",
    "data-name": "Path 276",
    d: "M343.023,170.258l-1.465,8.5c-.031.423-1.832,1.312-2.255,1.281h-.013l-9.628-.544a1.914,1.914,0,0,1-1.678-2.1c.567-4.2,1.048-6.182,1.718-11.488.395-3.259.867-9.736,2.108-14.106s5.526-3.026,5.386-1.067c-.311,4.65,1.938,11.292,3.958,14.6C341.5,165.917,343.107,169.59,343.023,170.258Z",
    transform: "translate(-255.273 -121.295)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_277",
    "data-name": "Path 277",
    d: "M343.856,170.791l-2.933,8.72c-.031.423-1.2.562-1.62.531h-.013l-9.628-.544a1.914,1.914,0,0,1-1.678-2.1c.567-4.2,1.048-6.182,1.718-11.488.395-3.259.867-9.736,2.108-14.106s5.526-3.026,5.386-1.067c-.311,4.65,1.938,11.292,3.958,14.6C341.5,165.917,343.94,170.123,343.856,170.791Z",
    transform: "translate(-255.273 -121.295)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_278",
    "data-name": "Path 278",
    d: "M380.086,243.218c1.048-4.922,4.783-23.4,4.2-35.152-2.862,4.844-9.258,16.91-10.309,29.391C373.453,243.658,376.271,244.933,380.086,243.218Z",
    transform: "translate(-255.273 -121.295)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_279",
    "data-name": "Path 279",
    d: "M349.778,251.82s2.646-19,22.6-22.5c0,0,14.373-18.333,32.452-36.737l-9.663-50.368,10.448-5.275s22.2,37.772,18.92,62.444-39.806,59.672-39.806,59.672Z",
    transform: "translate(-255.273 -121.295)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_280",
    "data-name": "Path 280",
    d: "M349.778,251.82s2.646-19,22.6-22.5c0,0,14.373-18.333,32.452-36.737l-9.663-50.368,10.448-5.275s22.2,37.772,18.92,62.444-39.806,59.672-39.806,59.672Z",
    transform: "translate(-255.273 -121.295)",
    fill: "#eef3ff",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_74",
    "data-name": "Group 74",
    transform: "translate(90.266 103.999)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_281",
    "data-name": "Path 281",
    d: "M383.179,232.13a6.833,6.833,0,0,1-6.36,6.8l-23.98,1.67a6.827,6.827,0,0,1-6.98-4.77,6.716,6.716,0,0,1-.3-1.57c-.01-.16-.02-.32-.02-.48a6.824,6.824,0,0,1,6.35-6.8l23.99-1.67a6.837,6.837,0,0,1,7.28,6.34C383.169,231.81,383.179,231.97,383.179,232.13Z",
    transform: "translate(-345.539 -225.294)",
    fill: "#003fb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_282",
    "data-name": "Path 282",
    d: "M382.029,229.95a6.832,6.832,0,0,1-6.35,6.8l-23.99,1.67a6.809,6.809,0,0,1-5.83-2.59,6.716,6.716,0,0,1-.3-1.57c-.01-.16-.02-.32-.02-.48a6.824,6.824,0,0,1,6.35-6.8l23.99-1.67a6.81,6.81,0,0,1,5.83,2.59,6.716,6.716,0,0,1,.3,1.57C382.019,229.63,382.029,229.79,382.029,229.95Z",
    transform: "translate(-345.539 -225.294)",
    fill: "#fff",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_75",
    "data-name": "Group 75",
    transform: "translate(64.779 122.795)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_283",
    "data-name": "Path 283",
    d: "M386.824,260.949a17.164,17.164,0,0,0-12.158-16.11c-12.527-4.295-10.709,11.287-10.709,11.287l22.341,5.745Z",
    transform: "translate(-320.051 -244.09)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_284",
    "data-name": "Path 284",
    d: "M386.824,260.949a17.164,17.164,0,0,0-12.158-16.11c-12.527-4.295-10.709,11.287-10.709,11.287l22.341,5.745Z",
    transform: "translate(-320.051 -244.09)",
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_285",
    "data-name": "Path 285",
    d: "M370.878,245.837s12.636,3.024,15.18,13.344-15.16,33-22.525,37.019-36.838,7.874-40.337,3.658c-12.052-14.522,13.8-38.049,22.7-43.823S370.878,245.837,370.878,245.837Z",
    transform: "translate(-320.051 -244.09)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_286",
    "data-name": "Path 286",
    d: "M323.2,299.862a2.41,2.41,0,0,0,.577.488c2.3,1.458,8.631,1.608,15.688,1.007,8.864-.765,18.871-2.726,23.346-4.806.265-.12.5-.24.721-.355,5.694-3.1,17.556-17.342,21.487-28.411,1.16-3.264,1.621-6.255,1.042-8.6-2.548-10.321-15.18-13.347-15.18-13.347s-16.088,4.429-24.989,10.2S311.142,285.335,323.2,299.862Z",
    transform: "translate(-320.051 -244.09)",
    fill: "#fff",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_287",
    "data-name": "Path 287",
    d: "M323.775,300.35c2.3,1.458,8.631,1.608,15.688,1.007,14.554-15.664,6.251-27.7,6.251-27.7C333.465,272.541,324.852,289.388,323.775,300.35Z",
    transform: "translate(-320.051 -244.09)",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_76",
    "data-name": "Group 76",
    transform: "translate(64.272 109.279)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_288",
    "data-name": "Path 288",
    d: "M380.086,243.218s-2.131-10.914-4.583-12.25-29.218,1.076-32.644,2.358-21.9,17.458-23.135,22.018,4.358,16.379,4.358,16.379,19.121,3.82,26.916.569S378.083,249.2,380.086,243.218Z",
    transform: "translate(-319.545 -230.574)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_289",
    "data-name": "Path 289",
    d: "M324.085,271.727s19.118,3.812,26.914.564,27.088-23.086,29.085-29.076c0,0-2.13-10.916-4.583-12.25s-29.216,1.076-32.643,2.358-21.9,17.461-23.13,22.022a9.9,9.9,0,0,0,.1,4.189C320.818,264.824,324.085,271.727,324.085,271.727Z",
    transform: "translate(-319.545 -230.574)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_290",
    "data-name": "Path 290",
    d: "M319.832,259.534c2.584.485,19.4,3.5,26.583.506,7.793-3.257,27.088-23.086,29.086-29.075-2.454-1.335-29.216,1.076-32.643,2.358s-21.9,17.461-23.13,22.022A9.9,9.9,0,0,0,319.832,259.534Z",
    transform: "translate(-319.545 -230.574)",
    fill: "#fff",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_80",
    "data-name": "Group 80",
    transform: "translate(30.18 122.785)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_77",
    "data-name": "Group 77"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_23",
    "data-name": "Ellipse 23",
    cx: 24.919,
    cy: 24.919,
    r: 24.919,
    transform: "translate(0 32.796) rotate(-41.152)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_24",
    "data-name": "Ellipse 24",
    cx: 24.919,
    cy: 24.919,
    r: 24.919,
    transform: "translate(0 32.796) rotate(-41.152)",
    fill: "#fff",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_291",
    "data-name": "Path 291",
    d: "M328.995,301.643a23.919,23.919,0,1,0-30.784-14.021A23.946,23.946,0,0,0,328.995,301.643Z",
    transform: "translate(-285.453 -244.08)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_25",
    "data-name": "Ellipse 25",
    cx: 17.978,
    cy: 13.42,
    rx: 17.978,
    ry: 13.42,
    transform: "translate(29.245 52.905) rotate(-76.02)",
    opacity: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_79",
    "data-name": "Group 79",
    transform: "translate(23.197 18.901)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_292",
    "data-name": "Path 292",
    d: "M324.029,291.762s4.663,4.591,6.052,3.437,4.079,2.39,6.327.378,6.659-7.876,4.437-13.4S324.486,283.495,324.029,291.762Z",
    transform: "translate(-308.65 -262.981)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_293",
    "data-name": "Path 293",
    d: "M324.03,291.756s4.666,4.6,6.052,3.448a1.412,1.412,0,0,1,1.436-.1c1.419.483,3.272,1.926,4.887.478,2.256-2.019,6.66-7.884,4.434-13.4-.949-2.367-4.092-2.462-7.411-1.145a16.883,16.883,0,0,0-2.583,1.286c-3.38,2.066-6.386,5.39-6.786,9.031C324.045,291.483,324.035,291.626,324.03,291.756Z",
    transform: "translate(-308.65 -262.981)",
    fill: "#fff",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_294",
    "data-name": "Path 294",
    d: "M324.03,291.756s4.666,4.6,6.052,3.448a1.412,1.412,0,0,1,1.436-.1c5.556-3.328,3.03-11.277,1.91-14.071a16.883,16.883,0,0,0-2.583,1.286,50.95,50.95,0,0,0-6.786,9.031C324.045,291.483,324.035,291.626,324.03,291.756Z",
    transform: "translate(-308.65 -262.981)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_295",
    "data-name": "Path 295",
    d: "M314.03,291.385a3.264,3.264,0,0,0,.507.013c4.782-.23,3.454-9.8,1.132-15.265-1.033-2.421-2.431-3.531-3.7-3.59-1.614-.09-3.032,1.487-3.3,4.17-.182,1.8,1,4.271.806,5.464C309.3,283.332,309.733,291.028,314.03,291.385Z",
    transform: "translate(-308.65 -262.981)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_296",
    "data-name": "Path 296",
    d: "M314.03,291.385a3.264,3.264,0,0,0,.507.013c4.782-.23,3.454-9.8,1.132-15.265-1.033-2.421-2.431-3.531-3.7-3.59-1.614-.09-3.032,1.487-3.3,4.17-.182,1.8,1,4.271.806,5.464C309.3,283.332,309.733,291.028,314.03,291.385Z",
    transform: "translate(-308.65 -262.981)",
    fill: "#fff",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_297",
    "data-name": "Path 297",
    d: "M314.03,291.385a3.264,3.264,0,0,0,.507.013c4.782-.23,3.454-9.8,1.132-15.265-1.033-2.421-2.431-3.531-3.7-3.59a7.6,7.6,0,0,0-1.026.854c-1.588,1.576.018,7.67-.043,9.273C310.83,284.115,311.376,288.972,314.03,291.385Z",
    transform: "translate(-308.65 -262.981)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_298",
    "data-name": "Path 298",
    d: "M331.125,275.2c1.841,7.219,3.287,11.354.862,16.107-3.648,7.148-13.476,6.632-17.447.089-3.575-5.89-5.984-16.706.076-21.689A10.278,10.278,0,0,1,331.125,275.2Z",
    transform: "translate(-308.65 -262.981)",
    fill: "#ebb376"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_78",
    "data-name": "Group 78",
    transform: "translate(10.964 23.154)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_304",
    "data-name": "Path 304",
    d: "M323.639,291.052c-.159.112-.341.216-.521.319l-3.5-1.785s.124-.2.344-.486c.718-1,2.451-3.138,4.021-2.954a2.837,2.837,0,0,1,.522.13,2.747,2.747,0,0,1,1.5,1.173C326.445,288.287,326.136,289.514,323.639,291.052Z",
    transform: "translate(-319.614 -286.135)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_305",
    "data-name": "Path 305",
    d: "M324.5,286.276l-4.093,2.975-.45-.151c.718-1,2.451-3.138,4.021-2.954A2.837,2.837,0,0,1,324.5,286.276Z",
    transform: "translate(-319.614 -286.135)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_307",
    "data-name": "Path 307",
    d: "M331.125,285.816s-2.831,5.445-3.935,6.633-4.523,2.325-4.523,2.325",
    transform: "translate(-308.65 -262.981)",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308",
    "data-name": "Path 308",
    d: "M322.87,295.438l1.05-.393a.709.709,0,0,0,.415-.912h0a.709.709,0,0,0-.912-.416l-1.05.393a.708.708,0,0,0-.415.912h0A.708.708,0,0,0,322.87,295.438Z",
    transform: "translate(-308.65 -262.981)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309",
    "data-name": "Path 309",
    d: "M335.755,280.224a7,7,0,0,1-2.074,4.974c-1.776,1.728-3.869.426-4.386-1.869-.465-2.066-.1-5.454,2.166-6.316A3.215,3.215,0,0,1,335.755,280.224Z",
    transform: "translate(-308.65 -262.981)",
    fill: "#ebb376"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_310",
    "data-name": "Path 310",
    d: "M314.847,272.223c2.2-.7,7.952-1.669,9.235-.5s3.946,15.167,6.81,16,7.9-3.871,7.474-8.111a9.46,9.46,0,0,0-3.06-6.3s-.755-11.143-12.366-10.284-14.427,10.361-14.275,13.683A12.182,12.182,0,0,1,314.847,272.223Z",
    transform: "translate(-308.65 -262.981)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_311",
    "data-name": "Path 311",
    d: "M314.847,272.223c2.2-.7,7.952-1.669,9.235-.5s3.946,15.167,6.81,16,7.9-3.871,7.474-8.111a9.46,9.46,0,0,0-3.06-6.3s-.755-11.143-12.366-10.284-14.427,10.361-14.275,13.683A12.182,12.182,0,0,1,314.847,272.223Z",
    transform: "translate(-308.65 -262.981)",
    fill: "#fff",
    opacity: 0.9
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_312",
    "data-name": "Path 312",
    d: "M305.893,258.143l1.538-.421a28.672,28.672,0,0,1,14.6-4.261c8.939-.269,22.114,7.825,24.342,23.517.086.607.145,1.149.192,1.663a13.489,13.489,0,0,1,.089,1.365c0,.017,0,.034,0,.051a11.459,11.459,0,0,1-.07,1.71c-.821,9.429-8.661,16.536-8.661,16.536a30.955,30.955,0,0,1-10.2,6.332l-1.763-1.056c16.067-6.459,13.62-24.059,13.62-24.06l-5.458-10.331s-14.609-16.606-31.843-6.83l-.707-.618A30.041,30.041,0,0,1,305.893,258.143Z",
    transform: "translate(-285.453 -244.08)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_313",
    "data-name": "Path 313",
    d: "M301.578,261.74l.7.614c17.24-9.77,31.845,6.835,31.845,6.835l5.456,10.333s2.452,17.6-13.613,24.055l1.763,1.06a31.3,31.3,0,0,0,4.579-2.173,27.172,27.172,0,0,0,5.618-4.162s7.836-7.107,8.655-16.531a11.131,11.131,0,0,0,.074-1.715.1.1,0,0,1,0-.054c-.005-.468-.046-.922-.094-1.364-.041-.508-.105-1.05-.193-1.657-2.222-15.7-15.4-23.791-24.337-23.524a28.944,28.944,0,0,0-14.508,4.2c-.058.043-.092.066-.092.066l-1.542.417A30.54,30.54,0,0,0,301.578,261.74Z",
    transform: "translate(-285.453 -244.08)",
    fill: "#fff",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_314",
    "data-name": "Path 314",
    d: "M301.578,261.74l.7.614c17.24-9.77,31.845,6.835,31.845,6.835l5.456,10.333s2.452,17.6-13.613,24.055l1.763,1.06a31.3,31.3,0,0,0,4.579-2.173c4.318-3.868,11.494-15.852,8.288-22.394a65.581,65.581,0,0,1-4.58-12.241s-12.905-14.145-28.491-10.171c-.536.136-1.084.3-1.634.483A30.54,30.54,0,0,0,301.578,261.74Z",
    transform: "translate(-285.453 -244.08)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_315",
    "data-name": "Path 315",
    d: "M335.122,268.034c1.721-.644,3.716.046,5.4,1.625a7.592,7.592,0,0,1,3.536,9.45c-.231,2.294-1.283,4.124-3,4.768-2.895,1.083-6.569-1.586-8.206-5.96S332.227,269.118,335.122,268.034Z",
    transform: "translate(-285.453 -244.08)",
    fill: "#003fb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_317",
    "data-name": "Path 317",
    d: "M336.83,276.425c1.133,3.026,3.674,4.872,5.676,4.123s2.709-3.81,1.576-6.836-3.673-4.872-5.676-4.123S335.7,273.4,336.83,276.425Z",
    transform: "translate(-285.453 -244.08)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_318",
    "data-name": "Path 318",
    d: "M301.359,268.773a33.046,33.046,0,0,1,5.195,1.131,31.888,31.888,0,0,1,7.632-7.511s-2.674-1.263-7.8-.084A22.341,22.341,0,0,0,301.359,268.773Z",
    transform: "translate(-285.453 -244.08)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_319",
    "data-name": "Path 319",
    d: "M300.137,287.424a34.582,34.582,0,0,1,5.375-16c-1.647-.719-3.237-1.373-4.524-1.874C298.8,274.277,297.2,280.813,300.137,287.424Z",
    transform: "translate(-285.453 -244.08)",
    fill: "#fff",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_320",
    "data-name": "Path 320",
    d: "M406.664,139.11l-10.218,6.582a.769.769,0,0,1-1.071-.182l-.007-.01-5.71-7.771a1.914,1.914,0,0,1,.553-2.633c3.6-2.239,5.434-3.128,9.953-5.989,2.765-1.77,8.06-5.53,12.22-7.355s5.852,2.335,4.252,3.474c-3.784,2.72-7.475,8.683-8.743,12.351A3.037,3.037,0,0,1,406.664,139.11Z",
    transform: "translate(-255.273 -121.295)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321",
    "data-name": "Path 321",
    d: "M406.664,139.11l-10.218,6.582a.769.769,0,0,1-1.071-.182l-.007-.01-5.71-7.771a1.914,1.914,0,0,1,.553-2.633c3.6-2.239,5.434-3.128,9.953-5.989,2.765-1.77,8.06-5.53,12.22-7.355s5.852,2.335,4.252,3.474c-3.784,2.72-7.475,8.683-8.743,12.351A3.037,3.037,0,0,1,406.664,139.11Z",
    transform: "translate(-255.273 -121.295)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_322",
    "data-name": "Path 322",
    d: "M407.66,138.071l.783,2.092-13.073,6.5-.655-1.75Z",
    transform: "translate(-255.273 -121.295)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_323",
    "data-name": "Path 323",
    d: "M340.955,164.994s3.059,9.833-2.311,15.369l1.832,1.162s6.6-6.731,2.616-15.376Z",
    transform: "translate(-255.273 -121.295)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_324",
    "data-name": "Path 324",
    d: "M404.166,193.262l.4-2.034s8.62-5.856,20.235.478l.023,4.282S414.961,189.133,404.166,193.262Z",
    transform: "translate(-255.273 -121.295)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_325",
    "data-name": "Path 325",
    d: "M382.354,199.252s-10.66,14.29-21.008,9.987l-.335-2s9.324,3.459,19.3-10.5Z",
    transform: "translate(-255.273 -121.295)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_326",
    "data-name": "Path 326",
    d: "M362.809,296.551c.265-.12.5-.24.721-.355,5.694-3.1,17.556-17.342,21.487-28.411-6.036,1.617-21.333,6.049-26.108,10.579C353.258,283.724,356.026,294.775,362.809,296.551Z",
    transform: "translate(-255.273 -121.295)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_327",
    "data-name": "Path 327",
    d: "M340.955,164.994s3.059,9.833-2.311,15.369l1.832,1.162s6.6-6.731,2.616-15.376Z",
    transform: "translate(-255.273 -121.295)",
    fill: "#003fb9",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328",
    "data-name": "Path 328",
    d: "M382.354,199.252s-10.66,14.29-21.008,9.987l-.335-2s9.324,3.459,19.3-10.5Z",
    transform: "translate(-255.273 -121.295)",
    fill: "#003fb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_329",
    "data-name": "Path 329",
    d: "M407.66,138.071l.783,2.092-13.073,6.5-.655-1.75Z",
    transform: "translate(-255.273 -121.295)",
    fill: "#003fb9",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_330",
    "data-name": "Path 330",
    d: "M404.166,193.262l.4-2.034s8.62-5.856,20.235.478l.023,4.282S414.961,189.133,404.166,193.262Z",
    transform: "translate(-255.273 -121.295)",
    fill: "#003fb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_331",
    "data-name": "Path 331",
    d: "M373.587,246.781a62.536,62.536,0,0,1,5.443,5.8c5.973,7.163,13.811,20.059,1.056,27.1",
    transform: "translate(-255.273 -121.295)",
    fill: "none",
    stroke: "#3659a7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_332",
    "data-name": "Path 332",
    d: "M368.543,254.316s20.472,14.647,9.791,31.16",
    transform: "translate(-255.273 -121.295)",
    fill: "none",
    stroke: "#3659a7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_83",
    "data-name": "Group 83",
    transform: "translate(97.136 151.328)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_333",
    "data-name": "Path 333",
    d: "M363.49,295.77c4.709-1.068,9.538-2.3,14.257-3.426,2.359-.6,4.717-1.134,7.031-1.665,2.291-.531,4.622-1,6.622-1.319.486-.079.972-.151,1.336-.192.408-.058.634-.057.593-.114a1.622,1.622,0,0,1-.351-.092l-.084-.036.1.019.2.039.818.156,1.682.34c2.287.459,4.646,1.036,7.042,1.561,4.786,1.072,9.69,2.222,14.68,3.021l.085.013a4.572,4.572,0,0,0,3.406-8.217,102.224,102.224,0,0,0-13.317-8.048c-2.316-1.2-4.694-2.286-7.194-3.333-.634-.264-1.247-.515-1.92-.75l-.992-.359-.248-.09-.127-.045-.315-.08c-.421-.1-.85-.2-1.276-.271a23.319,23.319,0,0,0-3.163-.252c-.89-.019-1.657,0-2.421.03-3,.131-5.624.483-8.273.831-2.622.369-5.183.834-7.727,1.3-5.087,1.011-10.02,2.122-15.027,3.571a9,9,0,0,0,4.467,17.434Z",
    transform: "translate(-352.409 -272.623)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_334",
    "data-name": "Path 334",
    d: "M363.49,295.77c4.709-1.068,9.538-2.3,14.257-3.426,2.359-.6,4.717-1.134,7.031-1.665,2.291-.531,4.622-1,6.622-1.319.486-.079.972-.151,1.336-.192.408-.058.634-.057.593-.114a1.622,1.622,0,0,1-.351-.092l-.084-.036.1.019.2.039.818.156,1.682.34c2.287.459,4.646,1.036,7.042,1.561,4.786,1.072,9.69,2.222,14.68,3.021l.085.013a4.572,4.572,0,0,0,3.406-8.217,102.224,102.224,0,0,0-13.317-8.048c-2.316-1.2-4.694-2.286-7.194-3.333-.634-.264-1.247-.515-1.92-.75l-.992-.359-.248-.09-.127-.045-.315-.08c-.421-.1-.85-.2-1.276-.271a23.319,23.319,0,0,0-3.163-.252c-.89-.019-1.657,0-2.421.03-3,.131-5.624.483-8.273.831-2.622.369-5.183.834-7.727,1.3-5.087,1.011-10.02,2.122-15.027,3.571a9,9,0,0,0,4.467,17.434Z",
    transform: "translate(-352.409 -272.623)",
    fill: "#fff",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_81",
    "data-name": "Group 81",
    transform: "translate(64.548 13.545)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_335",
    "data-name": "Path 335",
    d: "M419.382,286.965l8.7-.8-3.363,9.086s-7.8.242-7.76-3.784Z",
    transform: "translate(-416.957 -286.168)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_336",
    "data-name": "Path 336",
    d: "M435.849,289.976l-5.544,6.83-5.588-1.552,3.364-9.086Z",
    transform: "translate(-416.957 -286.168)",
    fill: "#407bff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_82",
    "data-name": "Group 82",
    transform: "translate(64.548 13.545)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_337",
    "data-name": "Path 337",
    d: "M419.382,286.965l8.7-.8-3.363,9.086s-7.8.242-7.76-3.784Z",
    transform: "translate(-416.957 -286.168)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_338",
    "data-name": "Path 338",
    d: "M435.849,289.976l-5.544,6.83-5.588-1.552,3.364-9.086Z",
    transform: "translate(-416.957 -286.168)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_339",
    "data-name": "Path 339",
    d: "M422.046,286.721s-4.775,2.5-3.349,7.388l-2.038-.173s-2.441-4.8,4.251-8.078Z",
    transform: "translate(-352.409 -272.623)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_340",
    "data-name": "Path 340",
    d: "M360.992,277.555s-13.329,10.891,1.4,18.4l-1.739.651s-8.05-.359-8.239-9.324C352.234,278.54,360.992,277.555,360.992,277.555Z",
    transform: "translate(-352.409 -272.623)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_341",
    "data-name": "Path 341",
    d: "M395.521,272.882s-4.6,5.938-2.192,16.172l-1.217.2a21.6,21.6,0,0,1,1.983-16.533Z",
    transform: "translate(-352.409 -272.623)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_342",
    "data-name": "Path 342",
    d: "M422.046,286.721s-4.775,2.5-3.349,7.388l-2.038-.173s-2.441-4.8,4.251-8.078Z",
    transform: "translate(-352.409 -272.623)",
    fill: "#003fb9",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_343",
    "data-name": "Path 343",
    d: "M360.992,277.555s-13.329,10.891,1.4,18.4l-1.739.651s-8.05-.359-8.239-9.324C352.234,278.54,360.992,277.555,360.992,277.555Z",
    transform: "translate(-352.409 -272.623)",
    fill: "#003fb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_344",
    "data-name": "Path 344",
    d: "M395.521,272.882s-4.6,5.938-2.192,16.172l-1.217.2a21.6,21.6,0,0,1,1.983-16.533Z",
    transform: "translate(-352.409 -272.623)",
    fill: "#003fb9"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_345",
    "data-name": "Path 345",
    d: "M367.754,234.93l-20.23,19.39h-7.07l20.56-19.39S365.084,232.26,367.754,234.93Z",
    transform: "translate(-255.273 -121.295)",
    fill: "#003fb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_346",
    "data-name": "Path 346",
    d: "M367.754,234.93l-20.23,19.39a5.241,5.241,0,0,0-7.07,0l20.56-19.39S365.084,232.26,367.754,234.93Z",
    transform: "translate(-255.273 -121.295)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_347",
    "data-name": "Path 347",
    d: "M345.325,236.66a6.207,6.207,0,0,1-1.02.55,5.363,5.363,0,0,1-1.881.42c-.74.01-1.3-.21-1.49-.64-.23-.55.211-1.28,1.03-1.89a5.489,5.489,0,0,1,1.181-.66,4.789,4.789,0,0,1,1.67-.41c.839-.07,1.49.15,1.689.63C346.744,235.24,346.244,236.03,345.325,236.66Z",
    transform: "translate(-255.273 -121.295)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_86",
    "data-name": "Group 86",
    transform: "translate(24.814 37.419)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_348",
    "data-name": "Path 348",
    d: "M294.4,160.56s2.44-.4,3.3-1.846",
    transform: "translate(-280.087 -158.714)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_349",
    "data-name": "Path 349",
    d: "M294.4,161.747a15.761,15.761,0,0,1,6.264-2.11",
    transform: "translate(-280.087 -158.714)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_350",
    "data-name": "Path 350",
    d: "M298.752,161.418s-1.319-.726-4.352.725",
    transform: "translate(-280.087 -158.714)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_84",
    "data-name": "Group 84",
    transform: "translate(0 0.656)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_351",
    "data-name": "Path 351",
    d: "M345.325,236.66a6.207,6.207,0,0,1-1.02.55,5.363,5.363,0,0,1-1.881.42c-.09-.65-.23-1.53-.46-2.53a18.535,18.535,0,0,0-4.33-8.76c-6.68-6.81-14.69-7.35-23.17-7.91-8.11-.54-16.5-1.1-24.09-7.21-7.74-6.23-11.61-17.91-9.88-29.76,1.561-10.63,7.18-18.88,15.05-22.09l1.13,2.78c-6.869,2.8-11.81,10.18-13.21,19.75-1.58,10.81,1.87,21.4,8.79,26.98,6.85,5.52,14.411,6.02,22.411,6.55,8.66.58,17.629,1.18,25.119,8.81a21.3,21.3,0,0,1,5.031,9.79C345.055,235.02,345.214,235.92,345.325,236.66Z",
    transform: "translate(-280.087 -159.37)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_85",
    "data-name": "Group 85",
    transform: "translate(0 0.656)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_352",
    "data-name": "Path 352",
    d: "M345.325,236.66a6.207,6.207,0,0,1-1.02.55,5.363,5.363,0,0,1-1.881.42c-.09-.65-.23-1.53-.46-2.53a18.535,18.535,0,0,0-4.33-8.76c-6.68-6.81-14.69-7.35-23.17-7.91-8.11-.54-16.5-1.1-24.09-7.21-7.74-6.23-11.61-17.91-9.88-29.76,1.561-10.63,7.18-18.88,15.05-22.09l1.13,2.78c-6.869,2.8-11.81,10.18-13.21,19.75-1.58,10.81,1.87,21.4,8.79,26.98,6.85,5.52,14.411,6.02,22.411,6.55,8.66.58,17.629,1.18,25.119,8.81a21.3,21.3,0,0,1,5.031,9.79C345.055,235.02,345.214,235.92,345.325,236.66Z",
    transform: "translate(-280.087 -159.37)",
    fill: "#fff"
  })))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "stars",
    transform: "translate(32 217.455)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "stars-2",
    "data-name": "stars",
    transform: "translate(454.883 312.331)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    "data-name": "Path 78",
    d: "M259.076,362.145l1.813.3-1.813.3-.3,1.813-.3-1.813-1.813-.3,1.813-.3.3-1.813Z",
    transform: "translate(-256.666 -360.332)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    "data-name": "Path 79",
    d: "M259.2,362.443l1.071,1.493-1.493-1.071-1.493,1.071,1.071-1.493-1.071-1.493,1.493,1.071,1.493-1.071Z",
    transform: "translate(-256.666 -360.332)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80",
    "data-name": "Path 80",
    d: "M259.2,362.443a.421.421,0,1,1-.421-.421A.421.421,0,0,1,259.2,362.443Z",
    transform: "translate(-256.666 -360.332)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "stars-3",
    "data-name": "stars",
    transform: "translate(399.978 288.797)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_92",
    "data-name": "Path 92",
    d: "M231.781,318.14l5.343.88-5.343.88-.88,5.343-.88-5.343-5.343-.88,5.343-.88.88-5.343Z",
    transform: "translate(-224.678 -312.797)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    "data-name": "Path 93",
    d: "M232.145,319.02l3.156,4.4-4.4-3.155-4.4,3.155,3.156-4.4-3.156-4.4,4.4,3.155,4.4-3.155Z",
    transform: "translate(-224.678 -312.797)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94",
    "data-name": "Path 94",
    d: "M232.14,319.02a1.24,1.24,0,1,1-1.239-1.24A1.239,1.239,0,0,1,232.14,319.02Z",
    transform: "translate(-224.678 -312.797)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "stars-4",
    "data-name": "stars",
    transform: "translate(499.919 368.242)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_108",
    "data-name": "Path 108",
    d: "M274.719,410.478l5.343.88-5.343.88-.88,5.343-.88-5.343-5.343-.88,5.343-.88.88-5.343Z",
    transform: "translate(-267.616 -405.136)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_109",
    "data-name": "Path 109",
    d: "M275.083,411.358l3.155,4.4-4.4-3.155-4.4,3.155,3.156-4.4-3.156-4.4,4.4,3.156,4.4-3.156Z",
    transform: "translate(-267.616 -405.136)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110",
    "data-name": "Path 110",
    d: "M275.078,411.358a1.24,1.24,0,1,1-1.239-1.239A1.24,1.24,0,0,1,275.078,411.358Z",
    transform: "translate(-267.616 -405.136)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "stars-5",
    "data-name": "stars",
    transform: "translate(162.212 240.331)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_78-2",
    "data-name": "Path 78",
    d: "M259.076,362.145l1.813.3-1.813.3-.3,1.813-.3-1.813-1.813-.3,1.813-.3.3-1.813Z",
    transform: "translate(-256.666 -360.332)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79-2",
    "data-name": "Path 79",
    d: "M259.2,362.443l1.071,1.493-1.493-1.071-1.493,1.071,1.071-1.493-1.071-1.493,1.493,1.071,1.493-1.071Z",
    transform: "translate(-256.666 -360.332)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80-2",
    "data-name": "Path 80",
    d: "M259.2,362.443a.421.421,0,1,1-.421-.421A.421.421,0,0,1,259.2,362.443Z",
    transform: "translate(-256.666 -360.332)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "stars-6",
    "data-name": "stars",
    transform: "translate(187.716 216.797)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_92-2",
    "data-name": "Path 92",
    d: "M231.781,318.14l5.343.88-5.343.88-.88,5.343-.88-5.343-5.343-.88,5.343-.88.88-5.343Z",
    transform: "translate(-224.678 -312.797)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93-2",
    "data-name": "Path 93",
    d: "M232.145,319.02l3.156,4.4-4.4-3.155-4.4,3.155,3.156-4.4-3.156-4.4,4.4,3.155,4.4-3.155Z",
    transform: "translate(-224.678 -312.797)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94-2",
    "data-name": "Path 94",
    d: "M232.14,319.02a1.24,1.24,0,1,1-1.239-1.24A1.239,1.239,0,0,1,232.14,319.02Z",
    transform: "translate(-224.678 -312.797)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "stars-7",
    "data-name": "stars",
    transform: "translate(208.3 296.242)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_108-2",
    "data-name": "Path 108",
    d: "M274.719,410.478l5.343.88-5.343.88-.88,5.343-.88-5.343-5.343-.88,5.343-.88.88-5.343Z",
    transform: "translate(-267.616 -405.136)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_109-2",
    "data-name": "Path 109",
    d: "M275.083,411.358l3.155,4.4-4.4-3.155-4.4,3.155,3.156-4.4-3.156-4.4,4.4,3.156,4.4-3.156Z",
    transform: "translate(-267.616 -405.136)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110-2",
    "data-name": "Path 110",
    d: "M275.078,411.358a1.24,1.24,0,1,1-1.239-1.239A1.24,1.24,0,0,1,275.078,411.358Z",
    transform: "translate(-267.616 -405.136)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "stars-8",
    "data-name": "stars",
    transform: "translate(0 12.445)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_108-3",
    "data-name": "Path 108",
    d: "M274.719,410.478l5.343.88-5.343.88-.88,5.343-.88-5.343-5.343-.88,5.343-.88.88-5.343Z",
    transform: "translate(-267.616 -405.136)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_109-3",
    "data-name": "Path 109",
    d: "M275.083,411.358l3.155,4.4-4.4-3.155-4.4,3.155,3.156-4.4-3.156-4.4,4.4,3.156,4.4-3.156Z",
    transform: "translate(-267.616 -405.136)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110-3",
    "data-name": "Path 110",
    d: "M275.078,411.358a1.24,1.24,0,1,1-1.239-1.239A1.24,1.24,0,0,1,275.078,411.358Z",
    transform: "translate(-267.616 -405.136)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "stars-9",
    "data-name": "stars",
    transform: "translate(691.555 314.443)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_108-4",
    "data-name": "Path 108",
    d: "M274.719,410.478l5.343.88-5.343.88-.88,5.343-.88-5.343-5.343-.88,5.343-.88.88-5.343Z",
    transform: "translate(-267.616 -405.136)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_109-4",
    "data-name": "Path 109",
    d: "M275.083,411.358l3.155,4.4-4.4-3.155-4.4,3.155,3.156-4.4-3.156-4.4,4.4,3.156,4.4-3.156Z",
    transform: "translate(-267.616 -405.136)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110-4",
    "data-name": "Path 110",
    d: "M275.078,411.358a1.24,1.24,0,1,1-1.239-1.239A1.24,1.24,0,0,1,275.078,411.358Z",
    transform: "translate(-267.616 -405.136)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "stars-10",
    "data-name": "stars",
    transform: "translate(170.806)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_108-5",
    "data-name": "Path 108",
    d: "M274.719,410.478l5.343.88-5.343.88-.88,5.343-.88-5.343-5.343-.88,5.343-.88.88-5.343Z",
    transform: "translate(-267.616 -405.136)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_109-5",
    "data-name": "Path 109",
    d: "M275.083,411.358l3.155,4.4-4.4-3.155-4.4,3.155,3.156-4.4-3.156-4.4,4.4,3.156,4.4-3.156Z",
    transform: "translate(-267.616 -405.136)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110-5",
    "data-name": "Path 110",
    d: "M275.078,411.358a1.24,1.24,0,1,1-1.239-1.239A1.24,1.24,0,0,1,275.078,411.358Z",
    transform: "translate(-267.616 -405.136)",
    fill: "#fff"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "ic_rocket",
    transform: "translate(73.167 265.343)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Plane",
    transform: "translate(0 29.237)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_64",
    "data-name": "Group 64",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_230",
    "data-name": "Path 230",
    d: "M57.351,248.453l3.741,1.5a6.712,6.712,0,0,1-1.151,5.091A5.622,5.622,0,0,1,55.9,257.14l-2.6-4.96Z",
    transform: "translate(-19.736 -220.164)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_231",
    "data-name": "Path 231",
    d: "M53.295,252.177l2.6,4.959a5.377,5.377,0,0,0,3.09-1.177,5.264,5.264,0,0,0,.945-.912,6.7,6.7,0,0,0,1.157-5.09l-3.742-1.5Z",
    transform: "translate(-19.734 -220.164)",
    fill: "#fff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_232",
    "data-name": "Path 232",
    d: "M55.495,252.177l2.6,4.959a5.377,5.377,0,0,0,3.09-1.177Z",
    transform: "translate(-21.934 -220.164)",
    fill: "#003fb9",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_233",
    "data-name": "Path 233",
    d: "M62.2,253.153,65.575,257s-.805,3.171-3.873,3.35-4.242-1.371-4.242-1.371l-.151-4.366Z",
    transform: "translate(-28.133 -220.164)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_234",
    "data-name": "Path 234",
    d: "M62.2,253.153,65.575,257s-.805,3.171-3.873,3.35-4.242-1.371-4.242-1.371l-.151-4.366Z",
    transform: "translate(-28.133 -220.164)",
    fill: "#fff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_235",
    "data-name": "Path 235",
    d: "M62.44,237.472c4.351,4.448,10.131,20.9,9.874,23.133s6.328,6.066,6.328,6.066l2.618-32.677s-4.466-3.9-6.395-4.457-5.949,3.922-9.319,1.148S62.44,237.472,62.44,237.472Z",
    transform: "translate(-48.944 -220.164)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_236",
    "data-name": "Path 236",
    d: "M72.319,260.605c-.149,1.238,1.828,2.979,3.61,4.271.011.009.011.009.012.019,1.416,1.025,2.7,1.773,2.7,1.773l2.625-32.675s-2.121-1.845-4.07-3.187a9.581,9.581,0,0,0-2.322-1.265c-1.934-.568-5.956,3.917-9.32,1.148a2.2,2.2,0,0,0-.9-.485c-1.2-.245-1.758,1.517-2.014,3.362l0,.02a27.514,27.514,0,0,0-.207,3.884C66.794,241.921,72.569,258.378,72.319,260.605Z",
    transform: "translate(-48.945 -220.164)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_237",
    "data-name": "Path 237",
    d: "M76.389,260.605c-.149,1.238,1.828,2.979,3.61,4.271-2.187-2.29-1.916-4.509-2.368-9.24s-3.187-14.015-3.187-14.015a15.139,15.139,0,0,1,2.651-7.107c1.557-2.409,3.007-3.484,4.168-3.708a9.581,9.581,0,0,0-2.322-1.265c-1.934-.568-5.956,3.917-9.32,1.148a2.2,2.2,0,0,0-.9-.485l-2.014,3.362,0,.02a27.514,27.514,0,0,0-.207,3.884C70.864,241.921,76.639,258.378,76.389,260.605Z",
    transform: "translate(-53.015 -220.164)",
    fill: "#003fb9",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_238",
    "data-name": "Path 238",
    d: "M94.751,248.458s-22.995-24.635-26.123-26.544-5.391-1.251-5.391-1.251-4.218-1.053-5.537-.094-.286,2.527,2.512,6.368c5.191,7.124,27.124,28.745,27.124,28.745S94.638,254.285,94.751,248.458Z",
    transform: "translate(-57.132 -220.164)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_239",
    "data-name": "Path 239",
    d: "M59.065,225.332c.332.483.72,1.02,1.145,1.6,5.19,7.128,27.128,28.749,27.128,28.749s7.3-1.4,7.412-7.231c0,0-22.994-24.633-26.12-26.536a9.054,9.054,0,0,0-3.321-1.273,5.191,5.191,0,0,0-2.073.023s-.187-.047-.5-.12-.764-.147-1.267-.226c-1.313-.191-3.01-.3-3.768.252C56.584,221.386,57.161,222.635,59.065,225.332Z",
    transform: "translate(-57.134 -220.164)",
    fill: "#fff",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240",
    "data-name": "Path 240",
    d: "M88.309,226.711l.531-.4a.9.9,0,0,0,.143-1.3c-.845-.99-2.209-2.842-2.088-4.361a5.191,5.191,0,0,0-2.073.023s-.187-.047-.5-.12c-.4,2.107,1.707,4.838,2.76,6.044A.9.9,0,0,0,88.309,226.711Z",
    transform: "translate(-78.72 -220.164)",
    fill: "#0b3558",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241",
    "data-name": "Path 241",
    d: "M92.343,225.332a6.651,6.651,0,0,0,2.406-5.011c-1.313-.191-3.01-.3-3.768.252C89.862,221.386,90.439,222.635,92.343,225.332Z",
    transform: "translate(-90.412 -220.164)",
    fill: "#003fb9",
    opacity: 0.43
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_249",
    "data-name": "Path 249",
    d: "M85.547,229.069l-.723-.746a.885.885,0,0,0-1.207-.062l-2.111,1.772a.886.886,0,0,0-.062,1.3l.787.8a.887.887,0,0,0,1.223.04l2.047-1.827A.887.887,0,0,0,85.547,229.069Z",
    transform: "translate(-72.236 -220.164)",
    fill: "#003fb9",
    opacity: 0.43
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3011",
    "data-name": "Group 3011",
    transform: "translate(90.313 7.034) rotate(97)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_348-2",
    "data-name": "Path 348",
    d: "M0,1.35A3.9,3.9,0,0,0,2.411,0",
    transform: "translate(10.468)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_349-2",
    "data-name": "Path 349",
    d: "M0,1.543A11.526,11.526,0,0,1,4.581,0",
    transform: "translate(10.468 0.675)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_350-2",
    "data-name": "Path 350",
    d: "M3.183.133S2.218-.4,0,.663",
    transform: "translate(10.468 1.845)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_84-2",
    "data-name": "Group 84",
    transform: "translate(0 0.48)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_351-2",
    "data-name": "Path 351",
    d: "M47.711,56.525a4.541,4.541,0,0,1-.746.4,3.922,3.922,0,0,1-1.376.307c-.066-.475-.168-1.119-.336-1.85a13.555,13.555,0,0,0-3.167-6.407C37.2,44,31.343,43.6,25.142,43.193c-5.931-.395-12.067-.8-17.618-5.273C1.863,33.364-.967,24.822.3,16.155,1.44,8.381,5.549,2.348,11.3,0l.826,2.033C7.107,4.081,3.494,9.478,2.47,16.477,1.315,24.383,3.838,32.128,8.9,36.209c5.01,4.037,10.539,4.4,16.39,4.79,6.333.424,12.893.863,18.371,6.443a15.574,15.574,0,0,1,3.679,7.16C47.514,55.326,47.63,55.984,47.711,56.525Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_85-2",
    "data-name": "Group 85",
    transform: "translate(0 0.48)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_352-2",
    "data-name": "Path 352",
    d: "M47.711,56.525a4.541,4.541,0,0,1-.746.4,3.922,3.922,0,0,1-1.376.307c-.066-.475-.168-1.119-.336-1.85a13.555,13.555,0,0,0-3.167-6.407C37.2,44,31.343,43.6,25.142,43.193c-5.931-.395-12.067-.8-17.618-5.273C1.863,33.364-.967,24.822.3,16.155,1.44,8.381,5.549,2.348,11.3,0l.826,2.033C7.107,4.081,3.494,9.478,2.47,16.477,1.315,24.383,3.838,32.128,8.9,36.209c5.01,4.037,10.539,4.4,16.39,4.79,6.333.424,12.893.863,18.371,6.443a15.574,15.574,0,0,1,3.679,7.16C47.514,55.326,47.63,55.984,47.711,56.525Z",
    fill: "#fff"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404IllustrationMed);
export default __webpack_public_path__ + "static/media/404_illustration_med.2ac07a34b09b42f29b3b123fcca60b7d.svg";
export { ForwardRef as ReactComponent };